import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Auth/LoginView.vue"),
  },
  {
    path: "/register",
    name: "register",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Auth/RegisterView.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Dashboard/DashboardIndexView.vue"
      ),
  },
  {
    path: "/dashboard/brands",
    name: "brandList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Dashboard/Businesses/BusinessListView.vue"
      ),
  },
  {
    path: "/dashboard/services",
    name: "serviceList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Dashboard/Businesses/ServicesListView.vue"
      ),
  },
  {
    path: "/dashboard/comments",
    name: "commentList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Dashboard/Comments/CommentListView.vue"
      ),
  },
  {
    path: "/dashboard/requests",
    name: "requestList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Dashboard/Reservations/ReservationListView.vue"
      ),
  },
  {
    path: "/dashboard/offersf",
    name: "offersList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Dashboard/Offers/OffersListView.vue"
      ),
  },
  {
    path: "/dashboard/connections",
    name: "connectionsList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      layout: "DashboardLayout",
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Dashboard/Connections/ConnectionListView.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  var isAuthenticated = false;
  var token = window.localStorage.getItem("token");
  if (to.name == "home") {
    if (token) {
      next({ name: "dashboard" });
    } else {
      next({ name: "login" });
    }
  }
  if (
    to.name !== "login" &&
    !token &&
    to.name !== "register" &&
    !isAuthenticated
  )
    next({ name: "login" });
  else next();

  next();
});

export default router;
